import { createFileRoute, redirect } from '@tanstack/react-router';
import { getActiveBrandId } from '../lib/active-brand.js';
import { brandsQuery, meQuery } from '../lib/queries.js';

// s264 — top-level /followups is now a redirector to the active
// brand's /home with the followups triage drawer pre-opened. The
// dedicated Followups tab + page were retired in favour of the rail-
// teaser + triage-drawer pattern; this stays alive for bookmarks.
export const Route = createFileRoute('/followups')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    const brands = await queryClient.ensureQueryData(brandsQuery());
    const live = brands.filter((b) => b.archivedAt === null);
    const activeId = getActiveBrandId();
    const target = live.find((b) => b.id === activeId) ?? live[0];
    if (!target) throw redirect({ to: '/brands' });
    throw redirect({
      to: '/brand/$slug/home',
      params: { slug: target.slug },
      search: { triage: 'followups' as const },
    });
  },
  component: () => null,
});
